var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("a", { attrs: { name: "scenario_analyzer" } }),
    _vm._v(" "),
    _c("fieldset", { staticStyle: { border: "3px groove" } }, [
      _c("legend", {}, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-white bold",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.showAnalyzer = !_vm.showAnalyzer
              },
            },
          },
          [_vm._v("\n        -\n      ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "ml-2 bold" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("financial-tools.sc_ana_title")) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showAnalyzer
        ? _c(
            "div",
            { staticClass: "p-1" },
            [
              _c("div", { staticClass: "bold" }, [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("financial-tools.sc_ana_subtitle_1") +
                          " " +
                          _vm.formatMoney(
                            _vm.bean.calcMortgageScenario.totalLoanAmount
                          ) +
                          " " +
                          _vm.$t("financial-tools.sc_ana_subtitle_2") +
                          " " +
                          _vm.formatRate(
                            _vm.bean.calcMortgageScenario.netRate
                          ) +
                          " " +
                          (_vm.bean.calcMortgageScenario.interestCompoundDd ==
                          _vm.MORTGAGE_FREQUENCY.MONTHLY
                            ? _vm.$t("financial-tools.sc_ana_subtitle_3a")
                            : _vm.$t("financial-tools.sc_ana_subtitle_3")) +
                          " " +
                          _vm.formatTerm(
                            _vm.bean.calcMortgageScenario.actualPaymentTerm
                          ) +
                          " "
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.bean.calcMortgageScenario.calcTypeFlag == "P"
                  ? _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("financial-tools.sc_ana_subtitle_4") +
                              " " +
                              _vm.formatTerm(
                                _vm.bean.calcMortgageScenario.amortizationTerm
                              ) +
                              " " +
                              _vm.lowerCase(
                                _vm.$t("application-form.amortization")
                              )
                          ) +
                          "\n        "
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("financial-tools.sc_ana_subtitle_4a") +
                              " " +
                              _vm.formatMoney(
                                _vm.bean.calcMortgageScenario
                                  .pAndIPaymentAmountMonthly
                              )
                          ) +
                          " "
                      ),
                    ]),
                _vm._v(":\n      "),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-5 bold" },
                [
                  _c("b-col", { staticClass: "mb-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.MORTGAGE_FREQUENCY, function (labela) {
                    return _c("b-col", { key: labela, staticClass: "mb-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("application-form." + labela)) +
                          "\n        "
                      ),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("b-row", { staticClass: "ml-3 bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("financial-tools.sc_list1_Fp")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("financial-tools.principal")) + ": "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.generatedMS, function (genms, ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoney(genms.principalFirstPaymentAmount)
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("financial-tools.interest")) + ": "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.generatedMS, function (genms, ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoney(genms.interestFirstPaymentAmount)
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "ml-3 bold" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("financial-tools.totals")) + ": "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.generatedMS, function (genms, ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatMoney(genms.pAndIPaymentAmount)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "mb-1 bold" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("financial-tools.effectiveAmortization")
                        ) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.generatedMS, function (genms, ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatTerm(genms.effectiveAmortization)
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mb-1 bold" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.balanceRemaining")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.generatedMS, function (genms, ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatMoney(genms.balanceRemaining)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "mb-1 bold" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_ana_sc_to_save")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.saveMS.length, function (ind) {
                    return _c(
                      "b-col",
                      { key: ind, staticClass: "mb-1 text-rigth" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.saveMS[ind - 1],
                              expression: "saveMS[ind - 1]",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.saveMS[ind - 1])
                              ? _vm._i(_vm.saveMS[ind - 1], null) > -1
                              : _vm.saveMS[ind - 1],
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.saveMS[ind - 1],
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.saveMS,
                                      ind - 1,
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.saveMS,
                                      ind - 1,
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.saveMS, ind - 1, $$c)
                              }
                            },
                          },
                        }),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1 text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-white bold",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.saveScenarios()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("financial-tools.sc_ana_button_save_sc")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }